import { render, staticRenderFns } from "./VuseNeuAvatar.vue?vue&type=template&id=4931ada1&"
import script from "./VuseNeuAvatar.vue?vue&type=script&lang=js&"
export * from "./VuseNeuAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports